module.exports = __webpack_public_path__ + "static/media/Tomahawk Warrior.6cba31ea.jpg";